/* Club IND Fundador · complementos del rediseño (solo /pages/club-fundador).
   Se ejecuta después de club-fundador-v5.js (ambos defer). No toca el formulario ni la medición. */
(function () {
  var r = document.getElementById('cf');
  if (!r) return;
  var D = r.dataset, goal = +D.goal || 20000, raised = +D.raised || 0;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Barra de meta (fase pre): valor real de data-raised, hoy 0. */
  var fill = document.getElementById('cfx-fill'), rs = document.getElementById('cfx-raised');
  if (rs) rs.textContent = '$' + Math.round(raised).toLocaleString('es-EC');
  if (fill) setTimeout(function () { fill.style.width = Math.min(100, raised / goal * 100) + '%'; }, 400);

  /* CTA fija (fase pre): lleva al formulario y enfoca el correo. */
  var email = document.getElementById('cf-email');
  function toForm(e) {
    if (!r.classList.contains('p-pre') || !email) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var f = email.closest('form') || email;
    window.scrollTo({ top: f.getBoundingClientRect().top + scrollY - 160, behavior: RM ? 'auto' : 'smooth' });
    setTimeout(function () { try { email.focus({ preventScroll: true }); } catch (x) { email.focus(); } }, RM ? 0 : 650);
  }
  [].forEach.call(document.querySelectorAll('#cf-stk-b, #cf .cfx-go'), function (a) {
    a.addEventListener('click', toForm, true);
  });

  /* Compartir: mensaje sin año de fundación (el de v5 decía "15 años"). */
  var url = 'https://indlovers.com/fundador?utm_source=whatsapp&utm_medium=referral&utm_campaign=fundador';
  var msg = 'Club IND Fundador: hoodie bordado y numerado, hecho en Quito. Con la preventa IND abre su primer pop-up fuera de Ecuador. Abre el 20 oct, 19:00 (hora de Ecuador) \uD83C\uDDEA\uD83C\uDDE8 ' + url;
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('#cf .share-btn');
    if (!a) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (navigator.share && /Mobi|Android|iPhone/i.test(navigator.userAgent)) {
      navigator.share({ title: 'Club Fundador IND', text: msg }).catch(function () {});
    } else {
      window.open('https://wa.me/?text=' + encodeURIComponent(msg), '_blank', 'noopener');
    }
  }, true);
  [].forEach.call(document.querySelectorAll('#cf .share-btn'), function (a) {
    a.href = 'https://wa.me/?text=' + encodeURIComponent(msg);
  });

  /* WhatsApp flotante: en el celular aparece cuando el hero sale de pantalla (no tapa el countdown). */
  var hero = r.querySelector('.hero');
  if (hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      document.documentElement.classList.toggle('cfx-past-hero', !es[0].isIntersecting);
    }).observe(hero);
  } else { document.documentElement.classList.add('cfx-past-hero'); }

})();
